import * as React from "react";
import { forwardRef } from "react";
const SvgOperation = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M10 21L10 14.9286C10 13.8635 10.8635 13 11.9286 13C12.9937 13 13.8571 13.8635 13.8571 14.9286V18.1429H16.4287C18 18.1429 19.4287 19 19.4287 21",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 6,
	y: 3,
	width: 4,
	height: 4,
	rx: 1,
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("rect", {
	x: 14,
	y: 3,
	width: 4,
	height: 4,
	rx: 1,
	stroke: "currentColor",
	strokeWidth: 1.5
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10 11V11C10 10.4477 9.55228 10 9 10H7C6.44772 10 6 10.4477 6 11V13C6 13.5523 6.44772 14 7 14H7.5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M14 11V11C14 10.4477 14.4477 10 15 10H17C17.5523 10 18 10.4477 18 11V13C18 13.5523 17.5523 14 17 14H16.5",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round"
}));
const ForwardRef = forwardRef(SvgOperation);
export default ForwardRef;
